import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DropzoneVariant } from './dropzone-variant.interface';
import { EInvoiceViewerService } from '../../services/einvoice-viewer.service';

@Component({
    selector: 'app-dropzone',
    templateUrl: './dropzone.component.html',
    styleUrls: ['./dropzone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropzoneComponent implements OnInit {
  @Input() variant: DropzoneVariant | undefined;

  @ViewChild('fileInputHidden') fileInput: ElementRef | undefined;
  @ViewChild('dropzone') dropzone: ElementRef | undefined;

  sourceFile: any;

  dragover: boolean = false;

  constructor(
    private einvoiceViewerService: EInvoiceViewerService,
    private cdr: ChangeDetectorRef
  ) {
  }
  dragOver() {
    this.dragover = true;
  }
  dragLeave() {
    this.dragover = false;
  }
  addFile() {
    this.fileInput?.nativeElement.click();
  }
  onFileChangeClick($event:any) {
    const files = $event.target.files;
    this.onFileChange(Array.from(files));
  }
  async onFileChange(pFileList: File[]) {
    this.dragover = false;
    this.einvoiceViewerService.filesAdded$.next(pFileList);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
  get dropzoneTextTranslation(): string {
    const text = $localize`:@@einvoice.dropzone.text:Drag & drop e-invoice file into this area <br />or click on icon to open file selection dialog`;
    return this.variant !== "small"
      ? text
      : text.replace(/<br \/>/g, ' ');
  }
  ngOnInit(): void {
    this.einvoiceViewerService.dragChanged$.subscribe(($event) => {
      if (!$event) {
        this.dragOver();

      } else {
        this.dragLeave();
      }
      this.cdr.markForCheck();
     });
  }
}
